import { baseApi } from '../Api';
import {
  META_GET_ALL,
  META_UPDATE,
  GET_ALL_TIMETABLES,
  SEARCH_TIMETABLES,
  GET_TIMETABLE_BY_ID,
  CREATE_TIMETABLE,
  UPDATE_TIMETABLE,
  DELETE_TIMETABLE,
  META_GET_DYNAMIC_FORM_FIELDS,
  REQUEST_TYPE_GET_ALL_DROPDOWN,
  BULK_DELETE_TIMETABLE,
} from './Endpoints';

export const timetableApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    // POST: Get all timetables (with filters, sorting, pagination) — query variant
    getAllTimetablesList: build.query({
      query: (body) => ({
        url: GET_ALL_TIMETABLES,
        method: 'POST',
        data: body,
      }),
    }),

    //  POST: Get all timetables (with filters, sorting, pagination)
    // getAllTimetables: build.mutation({
    //   query: ({requestTypeCode, body}) => ({
    //     url: `${GET_ALL_TIMETABLES}?requestTypeCode=${encodeURIComponent(requestTypeCode)}`,     //api/Timetable/get-all
    //     // url:GET_ALL_TIMETABLES,     //api/Timetable/get-all
    //     method: 'POST',
    //     // params: { requestTypeCode },
    //     data: body,
    //   }),
    // }),

    getAllTimetables: build.mutation({
      query: (body) => ({
        url: GET_ALL_TIMETABLES, //api/Timetable/get-all
        method: 'POST',
        // params: { requestTypeCode },
        data: body,
      }),
    }),

    //  POST: Search timetables
    searchTimetables: build.mutation({
      query: ({ requestTypeCode, body }) => ({
        // url: SEARCH_TIMETABLES,         // /api/Timetable/search
        url: `${SEARCH_TIMETABLES}?requestTypeCode=${encodeURIComponent(
          requestTypeCode
        )}`,
        method: 'POST',
        // params: { requestTypeCode },
        data: body,
      }),
    }),

    //  GET: Get single timetable by ID
    getTimetableById: build.query({
      query: (id) => ({
        url: `${GET_TIMETABLE_BY_ID}/${id}`,
        method: 'GET',
      }),
    }),

    //  POST: Create new timetable
    createTimetable: build.mutation({
      query: (body) => ({
        url: CREATE_TIMETABLE,
        method: 'POST',
        data: body,
      }),
      transformResponse: (raw) => {
        const code = `${raw?.errCode ?? ''}`.trim();

        // 409 → duplicate → throw error
        if (code === '409') {
          const err = new Error(raw?.errDescription ?? 'Duplicate entry');
          err.name = 'DuplicateError';
          err.data = raw;
          throw err;
        }

        // 410 → dependency error → return raw so component can show table
        if (code === '410') return raw;

        // 000 → success
        if (code === '000') return raw;

        // Any other error code → throw
        if (code && code !== '000') {
          const err = new Error(raw?.errDescription ?? 'Something went wrong');
          err.data = raw;
          throw err;
        }

        return raw;
      },
    }),

    //  PUT: Update existing timetable
    updateTimetable: build.mutation({
      query: ({ id, body }) => ({
        url: `${UPDATE_TIMETABLE}/${id}`,
        method: 'PUT',
        data: body,
      }),
      transformResponse: (raw) => {
        const code = `${raw?.errCode ?? ''}`.trim();

        // 410 → dependency error → return raw so component can show table
        if (code === '410') return raw;

        // 000 → success
        if (code === '000') return raw;

        // Any other error code → throw
        if (code && code !== '000') {
          const err = new Error(raw?.errDescription ?? 'Something went wrong');
          err.data = raw;
          throw err;
        }

        return raw;
      },
    }),

    //  DELETE: Delete a timetable
    deleteTimetable: build.mutation({
      query: ({ id }) => ({
        url: `${DELETE_TIMETABLE}/${id}`,
        method: 'DELETE',
      }),
      transformResponse: (raw) => {
        const code = `${raw?.errCode ?? ''}`.trim();

        // 410 → dependency error → return raw so component can show table
        if (code === '410') return raw;

        // 000 → success
        if (code === '000') return raw;

        // Any other error code → throw
        if (code && code !== '000') {
          const err = new Error(raw?.errDescription ?? 'Something went wrong');
          err.data = raw;
          throw err;
        }

        return raw;
      },
    }),

    // PUT: Bulk Delete work schedules
    bulkDeleteTimetable: build.mutation({
      query: (body) => ({
        url: BULK_DELETE_TIMETABLE,
        method: 'DELETE',
        data: body,
      }),
      transformResponse: (raw) => {
        const code = `${raw?.errCode ?? ''}`.trim();

        // 410 → dependency error → return raw so component can show table
        if (code === '410') return raw;

        // 000 → success
        if (code === '000') return raw;

        // Any other error code → throw
        if (code && code !== '000') {
          const err = new Error(raw?.errDescription ?? 'Something went wrong');
          err.data = raw;
          throw err;
        }

        return raw;
      },
    }),

    // ============================
    //  META DATA APIs
    // ============================

    // GET: Get all meta-data
    getMetaData: build.query({
      query: ({ companyId, tableCode }) => ({
        url: META_GET_ALL,
        method: 'GET',
        params: { companyId, tableCode },
      }),
    }),

    // PUT: Update meta-data
    updateMetaData: build.mutation({
      query: (body) => ({
        url: META_UPDATE,
        method: 'PUT',
        data: body,
      }),
    }),

    // Get Dynamic Form Fields for tab
    getDynamicFormFields: build.query({
      query: ({ companyId, formCode }) => ({
        url: META_GET_DYNAMIC_FORM_FIELDS,
        method: 'GET',
        params: { companyId, formCode },
      }),
    }),

    //  RequestType : Get All Request Types (Dropdown)
    getAllRequestTypeDropdown: build.mutation({
      query: ({ lookupCode, body }) => ({
        url: REQUEST_TYPE_GET_ALL_DROPDOWN,
        method: 'POST',
        params: { lookupCode },
        data: body,
      }),
    }),
  }),
});

export const {
  // Meta API hooks
  useGetMetaDataQuery,
  useLazyGetMetaDataQuery,
  useUpdateMetaDataMutation,

  useGetDynamicFormFieldsQuery,
  useLazyGetDynamicFormFieldsQuery,

  // RequestType API hooks
  useGetAllRequestTypeDropdownMutation,

  // Timetable API hooks
  useGetAllTimetablesListQuery,
  useLazyGetAllTimetablesListQuery,
  useGetAllTimetablesMutation,
  useSearchTimetablesMutation,
  useGetTimetableByIdQuery,
  useLazyGetTimetableByIdQuery,
  useCreateTimetableMutation,
  useUpdateTimetableMutation,
  useDeleteTimetableMutation,
  useBulkDeleteTimetableMutation,
} = timetableApi;
